<template>
  <div>
    <div class="cui__utils__heading">
      <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0"></h5>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <!-- <a class="btn btn-primary" href="javascript: void(0);"  @click="showModal('insert')">เพิ่มชุดบัญชี</a> -->
        </div>
      </div>
      <div class="card-body">
        <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0"></h5>
          </div>
          <!-- <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
              class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
          </div> -->
        </div>
        <a-table :columns="columns" :dataSource="data" rowKey='id' :pagination="false" >
          <h6 slot="scbBank" slot-scope="text , record">
            <input type="checkbox" class="form-check-input" @change="onChange(record.id, 'scbBank', record.scbBank)" v-model="record.scbBank" />
          </h6>
          <h6 slot="kbankBank" slot-scope="text , record">
            <input type="checkbox" class="form-check-input" @change="onChange(record.id, 'kbankBank', record.kbankBank)" v-model="record.kbankBank" />
          </h6>
          <h6 slot="ktbBank" slot-scope="text , record">
            <input type="checkbox" class="form-check-input" @change="onChange(record.id,'ktbBank', record.ktbBank)" v-model="record.ktbBank" />
          </h6>
          <h6 slot="bayBank" slot-scope="text , record">
            <input type="checkbox" class="form-check-input" @change="onChange(record.id,'bayBank', record.bayBank)" v-model="record.bayBank" />
          </h6>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
// import { Modal, notification } from 'ant-design-vue'
// import data from './data.json'
// import moment from 'moment'
import apiClient from '@/services/api'
import { getName } from '@/utils/status'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 10,
  },
  {
    title: 'bank',
    dataIndex: 'shortName',
    width: 20,
    align: 'center',
    scopedSlots: { customRender: 'shortName' },
  },
  {
    title: 'Scb',
    dataIndex: 'scbBank',
    className: 'scb',
    width: 50,
    align: 'center',
    scopedSlots: { customRender: 'scbBank' },
  },
  {
    title: 'Kbank',
    dataIndex: 'kbankBank',
    className: 'kbank',
    width: 50,
    align: 'center',
    scopedSlots: { customRender: 'kbankBank' },
  },
  {
    title: 'Ktb',
    dataIndex: 'ktbBank',
    className: 'ktb',
    width: 50,
    align: 'center',
    scopedSlots: { customRender: 'ktbBank' },
  },
  {
    title: 'Bay',
    dataIndex: 'bayBank',
    className: 'bay',
    width: 50,
    align: 'center',
    scopedSlots: { customRender: 'bayBank' },
  },
]
export default {
  data: function () {
    return {
      data: [],
      columns,
    //   record: {
    //     scbBank: false,
    //     kbankBank: false,
    //     ktbBank: false,
    //     bayBank: false,
    //   },
    }
  },

  methods: {
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    onChange(bankId, bankType, status) {
      if (bankId !== '' && bankType !== '') {
        this.getDataBankSetting(bankId, bankType, status)
      }
    },
    getDataBankSetting(bankId, bankType, status) {
      status = !status
      const sentData = {
        bankId: bankId,
        bankType: bankType,
        status: status = !status,
      }
      apiClient.post('bankSetting/saveData', sentData).then(response => {
        if (response.data.code === '000') {
          const iconError = (response.data.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: 'บันทึกข้อมูลสำเร็จ' })
          this.loaddata()
        } else {
          const iconError = (response.data.code !== '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: 'เกิดข้อผิดพลาด' })
          this.loaddata()
        }
      })
    },
    loaddata() {
      apiClient.get('bankSetting/').then(res => {
        if (res.data.code === '000') {
          this.data = res.data.responseData.data
          this.data.forEach(element => {
            this.form = {
              scbBank: element.scbBank,
              kbankBank: element.kbankBank,
              ktbBank: element.ktbBank,
              bayBank: element.bayBank,
            }
          })
        }
      })
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  created() {
    this.loaddata()
  },
}
</script>
<style>
[data-kit-theme="dark"] .ant-table-thead > tr > .scb {
  color: #ffffff;
  background: rgb(122, 88, 191);
}

[data-kit-theme="default"] .ant-table-thead > tr > .scb {
  color: #ffffff;
  background: rgb(122, 88, 191);
}

[data-kit-theme="dark"] .ant-table-thead > tr > .kbank {
  color: #ffffff;
  background: #00a950;
}

[data-kit-theme="default"] .ant-table-thead > tr > .kbank {
  color: #ffffff;
  background: #00a950;
}

[data-kit-theme="dark"] .ant-table-thead > tr > .ktb {
  color: #ffffff;
  background: #00A4E4;
}

[data-kit-theme="default"] .ant-table-thead > tr > .ktb {
  color: #ffffff;
  background: #00A4E4;
}

[data-kit-theme="dark"] .ant-table-thead > tr > .bay {
  color: #ffffff;
  background: #ffd400;
}

[data-kit-theme="default"] .ant-table-thead > tr > .bay {
  color: #ffffff;
  background: #ffd400;
}
[data-kit-theme="dark"] .ant-table-thead > tr > th {
  font-weight: 900;
}
[data-kit-theme="default"] .ant-table-thead > tr > th {
  font-weight: 900;
}
.form-check-input {
    width: 1em;
    height: 1em;
    margin-top: .25em;
    position: static;
    background-color: #fff;
    border-radius: .25em;
}
</style>
